export default __webpack_public_path__ + "static/testimonial-user-6-241673cd5221890e1e60f5ce1b1e8356.jpg";